// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
	padding-bottom: 19px;
}

select {
	height: 30px !important;
	padding-top: 6px;
	padding-bottom: 6px;
	padding-right: 28px;
  -o-appearance: none;
  appearance: none;
  border-radius: 0px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 0px;
  border: 1px solid #BFBFC0;
  font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
}

select::-ms-expand {
  display: none;
}

select + span {
  float: right;
  margin-top: -27px;
  margin-right: 5px;
  pointer-events: none;
  padding-right: 5px;
  height: 14px;
}

select + span img {
	width: 14px;
	height: 14px;
	vertical-align: -3px;
}



button.pre-req {
	text-decoration: none;
}
button.pre-req:hover {
	text-decoration: underline;
}


.btn-link {
	text-align: center;
 	width: auto;
 	padding-left: 0px;
 	padding-right: 0px;
 	font-family: MuseoSans-300;
 	font-size: 12px;
	color: #00A1E0;
}

.text-warn {
  font-family: MuseoSans-500;
  font-size: 11px;
  margin-top: 6px;
  color: #EA9E32;
}

.text-danger {
	font-family: MuseoSans-500;
	font-size: 11px;
	color: #ED1C24;
	width: 500px;
}

.text-danger:first-of-type {
	margin-top: -14px;
}

.form-group > label, input[type="file"] {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
}

.form-group .long-label {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
	width: 110%;
}

span.info > img {
	margin-top: 4px;
}

.actions {
	position: relative;
	bottom: 20px;
	right: 10px;
	margin-top: 36px;
	margin-right: -10px;
}

input.ng-invalid.ng-touched {
	border: 1px solid red;
}

.required-text {
	margin: 16px 0;
	font-family: MuseoSans-700;
	font-size: 13px;
	color: #ED1C24 !important;
}

.actions {
	position: relative;
	bottom: 20px;
	right: 10px;
	margin-top: 36px;
}

button {
	width: 100px;
}

.btn-primary {
	margin-left: 10px;
}

.required-field::after {
  content: "*";
  color: #ED1C24;
  font-size: 1rem !important;
}

.hide-show {
	font-family: MuseoSans-300;
	font-size: 11px;
	color: #404141;
	float: right;
  margin-right: 14px;
  margin-top: -38px;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

input.password {
	padding-right: 50px;
}

.beta {
    background: #F0F0F0;
    font-style: italic;
    font-weight: 100;
}

.tls input[type="checkbox"] {
	opacity: 0;
	width: 106px;
	cursor: pointer;
}

.tls input[type="checkbox"] + label {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
	margin: 0;
	margin-left: -106px;
	clear: none;
	padding-left: 34px;
	background: url('Unchecked.svg') left center no-repeat;
}

.tls input[type="checkbox"].checked + label {
	background: url('Checked.svg') left center no-repeat;
}

.text-error {
	font-family: MuseoSans-500;
	font-size: 11px;
	color: #ED1C24;
	width: 500px;
}

.text-remove{
  margin-top: 33px;
}

.text-cert {
  position: absolute;
  height: 22px;
  font-family: MuseoSans-500;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: #1F1F1F;
}

.removed-cert {
	text-decoration: line-through;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pbx/pbx.component.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;EAGlB,mBAAmB;EAEnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;CAC3B,eAAe;CACf,cAAc;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;AACrB;;;;AAIA;CACC,qBAAqB;AACtB;AACA;CACC,0BAA0B;AAC3B;;;AAGA;CACC,kBAAkB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;CAChB,cAAc;AACf;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;AAC5B;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,YAAY;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,SAAS;CACT,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,sDAA6E;AAC9E;;AAEA;CACC,oDAA2E;AAC5E;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,YAAY;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;CACC,6BAA6B;AAC9B","sourcesContent":[".title {\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n\tpadding-bottom: 19px;\n}\n\nselect {\n\theight: 30px !important;\n\tpadding-top: 6px;\n\tpadding-bottom: 6px;\n\tpadding-right: 28px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  border-radius: 0px;\n  -moz-border-radius: 0px;\n  -webkit-border-radius: 0px;\n  border: 1px solid #BFBFC0;\n  font-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n}\n\nselect::-ms-expand {\n  display: none;\n}\n\nselect + span {\n  float: right;\n  margin-top: -27px;\n  margin-right: 5px;\n  pointer-events: none;\n  padding-right: 5px;\n  height: 14px;\n}\n\nselect + span img {\n\twidth: 14px;\n\theight: 14px;\n\tvertical-align: -3px;\n}\n\n\n\nbutton.pre-req {\n\ttext-decoration: none;\n}\nbutton.pre-req:hover {\n\ttext-decoration: underline;\n}\n\n\n.btn-link {\n\ttext-align: center;\n \twidth: auto;\n \tpadding-left: 0px;\n \tpadding-right: 0px;\n \tfont-family: MuseoSans-300;\n \tfont-size: 12px;\n\tcolor: #00A1E0;\n}\n\n.text-warn {\n  font-family: MuseoSans-500;\n  font-size: 11px;\n  margin-top: 6px;\n  color: #EA9E32;\n}\n\n.text-danger {\n\tfont-family: MuseoSans-500;\n\tfont-size: 11px;\n\tcolor: #ED1C24;\n\twidth: 500px;\n}\n\n.text-danger:first-of-type {\n\tmargin-top: -14px;\n}\n\n.form-group > label, input[type=\"file\"] {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n}\n\n.form-group .long-label {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n\twidth: 110%;\n}\n\nspan.info > img {\n\tmargin-top: 4px;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tright: 10px;\n\tmargin-top: 36px;\n\tmargin-right: -10px;\n}\n\ninput.ng-invalid.ng-touched {\n\tborder: 1px solid red;\n}\n\n.required-text {\n\tmargin: 16px 0;\n\tfont-family: MuseoSans-700;\n\tfont-size: 13px;\n\tcolor: #ED1C24 !important;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tright: 10px;\n\tmargin-top: 36px;\n}\n\nbutton {\n\twidth: 100px;\n}\n\n.btn-primary {\n\tmargin-left: 10px;\n}\n\n.required-field::after {\n  content: \"*\";\n  color: #ED1C24;\n  font-size: 1rem !important;\n}\n\n.hide-show {\n\tfont-family: MuseoSans-300;\n\tfont-size: 11px;\n\tcolor: #404141;\n\tfloat: right;\n  margin-right: 14px;\n  margin-top: -38px;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\ninput.password {\n\tpadding-right: 50px;\n}\n\n.beta {\n    background: #F0F0F0;\n    font-style: italic;\n    font-weight: 100;\n}\n\n.tls input[type=\"checkbox\"] {\n\topacity: 0;\n\twidth: 106px;\n\tcursor: pointer;\n}\n\n.tls input[type=\"checkbox\"] + label {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n\tmargin: 0;\n\tmargin-left: -106px;\n\tclear: none;\n\tpadding-left: 34px;\n\tbackground: url('../../../assets/images/Unchecked.svg') left center no-repeat;\n}\n\n.tls input[type=\"checkbox\"].checked + label {\n\tbackground: url('../../../assets/images/Checked.svg') left center no-repeat;\n}\n\n.text-error {\n\tfont-family: MuseoSans-500;\n\tfont-size: 11px;\n\tcolor: #ED1C24;\n\twidth: 500px;\n}\n\n.text-remove{\n  margin-top: 33px;\n}\n\n.text-cert {\n  position: absolute;\n  height: 22px;\n  font-family: MuseoSans-500;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 22px;\n  color: #1F1F1F;\n}\n\n.removed-cert {\n\ttext-decoration: line-through;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
